import portsApi from '../framework/ports/portsApi';

const GameFrameFrontend = {
  getGameFrame: (callback: Function) =>
    portsApi.on('GameFrame.getGameFrame', callback),
  onMessage: (callback: Function) =>
    portsApi.on('GameFrame.onMessage', callback),
  postMessageToGameFrame: (topic: string, data: any) =>
    portsApi.invoke('GameFrame.postMessageToGameFrame', [topic, data]),
  exitFullscreen: () => portsApi.invoke('GameFrame.exitFullscreen'),
};

export default GameFrameFrontend;
